module.exports = __webpack_public_path__ + "assets/img/img319.15703f28.jpg";